module.exports = __webpack_public_path__ + "img/1.66d2ab05.png";